/* PBN gallery: self-hosted video slides + shared lightbox behaviour.

   Video notes:
   - Clips buffer on first contact with the gallery, not when their slide scrolls
     in. IntersectionObserver alone is too late: .splide__track clips off-screen
     slides to zero area, so a slide only registers once it is already arriving,
     which showed as a ~0.3s black frame on iOS. Galleries nobody touches still
     cost 0 bytes.
   - A poster <img> is held over each video until it is genuinely playing, because
     iOS paints black while a <video> decodes its first frame.
   - Expanded view uses GLightbox's inline type, so the clone it makes needs
     play() calling by hand. */
(function () {

  /* ---------- shared: click anywhere outside the media to close ---------- */
  document.addEventListener('click', function (e) {
    var container = document.querySelector('.glightbox-container');
    if (!container || !container.contains(e.target)) return;
    // Ignore the controls themselves.
    if (e.target.closest('.gclose, .gnext, .gprev, .gbtn')) return;
    // Ignore clicks that land on the media itself.
    if (e.target.closest('img, video, .gslide-media, .ginlined-content, .gslide-description')) return;
    var close = container.querySelector('.gclose');
    if (close) close.click();
  }, true);

  /* ---------- videos ---------- */
  var vids = Array.prototype.slice.call(
    document.querySelectorAll('video.pbn-gallery-video')
  );


  /* Swipe on an expanded clip: down/up closes, left/right moves to the next
     slide, matching how the photo slides already behave. GLightbox does not
     apply its own drag handling to inline slides, so this is ours. */
  function bindDrag(el) {
    var sx = 0, sy = 0, dx = 0, dy = 0, dragging = false;
    el.style.touchAction = 'none';

    function finish() {
      if (!dragging) return;
      dragging = false;
      el.style.transition = 'transform 180ms ease, opacity 180ms ease';
      el.style.transform = '';
      el.style.opacity = '';
      var box = document.querySelector('.glightbox-container');
      if (!box) return;
      var btn = null;
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 70) btn = box.querySelector('.gclose');
      else if (Math.abs(dx) > 60) btn = box.querySelector(dx < 0 ? '.gnext' : '.gprev');
      if (btn) btn.click();
    }

    el.addEventListener('pointerdown', function (e) {
      dragging = true; sx = e.clientX; sy = e.clientY; dx = 0; dy = 0;
      el.style.transition = 'none';
      if (el.setPointerCapture) { try { el.setPointerCapture(e.pointerId); } catch (err) {} }
    });
    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - sx;
      dy = e.clientY - sy;
      if (Math.abs(dy) > Math.abs(dx)) {
        el.style.transform = 'translateY(' + dy + 'px)';
        el.style.opacity = String(Math.max(0.25, 1 - Math.abs(dy) / 400));
      } else {
        el.style.transform = 'translateX(' + dx + 'px)';
      }
    });
    el.addEventListener('pointerup', finish);
    el.addEventListener('pointercancel', finish);
  }

  function play(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  // GLightbox clones our inline markup into its slide; start the clone.
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      records.forEach(function (rec) {
        Array.prototype.forEach.call(rec.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          var found = node.matches && node.matches('.pbn-lightbox-video')
            ? [node]
            : Array.prototype.slice.call(
                node.querySelectorAll ? node.querySelectorAll('.pbn-lightbox-video') : []
              );
          found.forEach(function (v) {
            v.removeAttribute('controls');
            bindDrag(v.closest('.pbn-lightbox-slide') || v);
            play(v);
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (!vids.length) return;

  function poster(v) {
    var wrap = v.closest('.pbn-gallery-media');
    return wrap ? wrap.querySelector('.pbn-gallery-poster') : null;
  }

  function buffer(v) {
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    v.src = v.dataset.src;
    v.load();
  }

  vids.forEach(function (v) {
    var img = poster(v);
    if (!img) return;
    v.addEventListener('playing', function () { img.classList.add('is-playing'); });
    v.addEventListener('emptied', function () { img.classList.remove('is-playing'); });
  });

  function bufferAll() { vids.forEach(buffer); }

  var gallery = vids[0].closest('.main-splide') || document;
  ['pointerdown', 'touchstart', 'mouseenter', 'keydown'].forEach(function (evt) {
    gallery.addEventListener(evt, bufferAll, { once: true, passive: true });
  });

  /* No idle preload (removed 2026-09-10). It buffered all three clips within
     ~4 s of load for every visitor, whether or not they touched the gallery.
     Clips now buffer on first contact with the gallery (above) or when their
     slide scrolls into view (below). */

  var io = ('IntersectionObserver' in window) && new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) { buffer(v); play(v); }
      else if (!v.paused) { v.pause(); }
    });
  }, { threshold: 0.25 });
  if (io) vids.forEach(function (v) { io.observe(v); });
  else { bufferAll(); vids.forEach(play); }
})();
